module.exports = __webpack_public_path__ + "components/country-flag/static/az-7358e61dbbc33881b38f2dea6a5dd482.svg";